/* eslint-disable autofix/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

interface IntersectionId {
  region: number | null;
  id: number;
}

// Define MovementPhaseState enum
export enum MovementPhaseState {
    unavailable = "unavailable",
    dark = "dark",
    stopThenProceed = "stopThenProceed",
    stopAndRemain = "stopAndRemain",
    preMovement = "preMovement",
    permissiveMovementAllowed = "permissiveMovementAllowed",
    protectedMovementAllowed = "protectedMovementAllowed",
    permissiveClearance = "permissiveClearance",
    protectedClearance = "protectedClearance",
    cautionConflictingTraffic = "cautionConflictingTraffic"
}

interface StateTimeSpeed {
    eventState: MovementPhaseState; // Use the enum here
    timing: {
        startTime: number;
        minEndTime: number;
        maxEndTime: number;
        likelyTime: number;
        confidence: number;
        nextTime: number;
    };
    speeds: any;
}

interface SignalState {
    signalGroup: number;
    stateTimeSpeed: StateTimeSpeed[];
    maneuverAssistList: any;
    movementName: any;
}

interface Status {
    manualControlIsEnabled: boolean;
    stopTimeIsActivated: boolean;
    failureFlash: boolean;
    preemptIsActive: boolean;
    signalPriorityIsActive: boolean;
    fixedTimeOperation: boolean;
    trafficDependentOperation: boolean;
    standbyOperation: boolean;
    failureMode: boolean;
    off: boolean;
    recentMAPmessageUpdate: boolean;
    recentChangeInMAPassignedLanesIDsUsed: boolean;
    noValidMAPisAvailableAtThisTime: boolean;
    noValidSPATisAvailableAtThisTime: boolean;
}

interface MetaData {
    id: string;
    partitionKey: string;
    schemaVersion: string;
    time: {
        occurred: string; // Date-time format
        duration: number | null;
        ingested: string; // Date-time format
        generated: string; // Date-time format
        processed: string | null; // Date-time format
    };
    locations: any[]; // As locations array is empty, specify `any[]` type, can be further detailed if needed
    source: {
        producer: {
            type: 'atms' | 'device' | 'crowdSource' | 'dataExchange' | 'dataFeed' | 'fleet';
            name: 'CvSystem' | 'Ford' | 'GeoTab' | 'HERE' | 'Intersection' | 'RSU' | 'SunGuide' | 'Waze';
            version: string;
            id: string;
        };
        interface: {
            app: 'J2735Producer' | 'HEREProducer' | 'SunGuideProducer' | 'WazeProducer' | 'FordProducer' | 'GeoTabProducer';
            connection: 'polled' | 'pushed' | 'persistent';
            version: string;
        };
        device: {
            enabled: boolean | null;
            error: boolean | null;
            errorCause: any;
            id: any;
        };
        references: {
            id: string;
            schema: 'RoadwayEvent' | 'Message' | 'Raw' | 'SignalTiming' | 'Map' | 'Traffic' | 'TravelTime' | 'Vehicle' | 'Weather' | 'Ford';
            occurrence: string; // Date-time format
        }[];
    };
    cancelled: boolean;
}

interface SPaTData {
  intersectionId: number;
  timeReceived: string;
  timeSent: string;
  dataJson: {
    metadata: MetaData;
    spatrecord: {
      timeStamp: number;
      name: string | null;
      intersection: {
        name: string;
        id: IntersectionId;
        revision: number;
        status: Status;
        minuteOfTheYear: number;
        timeStamp: number;
        enabledLanes: any;
        states: SignalState[];
        maneuverAssistList: any;
      };
      spatJ2735Uper: string;
    };
  };
}

export default SPaTData;
